import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
// Styles
import styles from "./Checkbox.module.scss";

const Checkbox = forwardRef(
  ({ className, disabled, name, label, value, error, ...restProps }, ref) => {
    return (
      <div className={styles.root}>
        <div className={cn(styles.checkboxWrapper, className)}>
          <input
            className={styles.checkboxInput}
            disabled={disabled}
            id={`${name}-${value}`}
            name={name}
            type="checkbox"
            value={value}
            ref={ref}
            {...restProps}
          />
          <label
            className={cn(styles.label, {
              [styles.disabled]: disabled,
            })}
            htmlFor={`${name}-${value}`}
          >
            {label}
          </label>
        </div>

        {error && <p className={styles.errorDescription}>{error}</p>}
      </div>
    );
  }
);

Checkbox.defaultProps = {
  className: "",
  disabled: false,
};

Checkbox.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  error: PropTypes.string,
};

export default Checkbox;
